export default (topBannerHeight) => ({
  top: topBannerHeight,
  height: `calc(100vh - ${topBannerHeight}px)`,
});
